<div class="tile-component">
  @for (data of tileValues; track data; let i = $index) {
    @if (data.hasOwnProperty('Visible') ? data.Visible : true) {
      <div
        [ngClass]="[ data.hasOwnProperty('Enabled') ? !data.Enabled ? 'disabled' : '' :'']" id="req-{{i + 1}}">
        <mat-card appearance="outlined" (click)="data.hasOwnProperty('RoutingUrl') && data.RoutingUrl ? routeToModule(data):return;">
          <mat-card-header>
            <mat-card-title>
              @if (data.skipSourceCombine == true) {
                <div class="sourceName">
                  {{data.TransactionsStatus}}
                </div>
              }
              @if (data.skipSourceCombine != true) {
                <div class="sourceName">
                  {{data.SourceName}} {{data.TransactionsStatus}}
                </div>
              }
            </mat-card-title>
            <mat-card-subtitle>{{data.TransactionsCount}} @if (data.navigate) {
              <i class="icon-back"></i>
            }
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class='content-icon' [ngStyle]="{'background-color':getColor(data)}">
            <i class="{{data.iconName}} {{data.class ? data.class : ''}} tile-icons"
            [ngStyle]="{'icon-color': data.TransactionsStatus === 'Seats Occupied'}"></i>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  }
}
</div>